import React, { useState, useEffect, useRef } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from 'notistack';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

function State() {
  const Token = JSON.parse(localStorage.getItem('tcn'));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setsearch] = useState('');
  const [stateList, setstateList] = useState([]);
  const [filterstateList, setfilterstateList] = useState([]);

  const StateInputRef = useRef(null);

  const [StateId, setStateId] = useState('');
  const [StateName, setStateName] = useState('');
  const [IsActive] = useState(true);
  const [CreatedBy] = useState(1);
  const [ModifiedBy] = useState(1);

  const [edit, setEdit] = useState(false);
  const [returnId, setreturnId] = useState(0);

  const ConcateURL = APIUrl.State;

  function doEmptyStates() {
    setStateId('');
    setStateName('');
    setEdit(false);
    setreturnId(0);
  }

  const parseJSON = async (response) => {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    }
    catch (err) {
      console.warn('Failed to parse JSON response', err);
      return null;
    }
  };

  const getAllState = async () => {
    try {
      const response = await fetch(ConcateURL + 'GetAllState', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify()
      });

      const result = await parseJSON(response);

      if (result && result.data !== null) {
        setstateList(result.data);
        setfilterstateList(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllState();
  }, []);

  const insertState = async () => {
    try {
      if (StateName.trim().length >= 2) {
        const data = { StateName, IsActive, CreatedBy, ModifiedBy };
        const response = await fetch(ConcateURL + 'InsertState', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Token}`
          },
          body: JSON.stringify(data)
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          enqueueSnackbar('Successfully Added', { variant: 'success' });
          getAllState();
          doEmptyStates();
        } else {
          enqueueSnackbar('Add failed: empty response', { variant: 'error' });
        }
      }
      else {
        enqueueSnackbar('Please enter state name', { variant: 'warning' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const editState = async (Id) => {
    try {
      const items = stateList.filter((x) => x.StateId === Id);

      items.forEach((item) => {
        setStateId(item.StateId);
        setStateName(item.StateName || item.State || '');
        setreturnId(item.StateId);
      });

      setEdit(true);
      StateInputRef.current.focus();
    }
    catch (error) {
      console.log(error);
    }
  };

  const updateState = async (Id) => {
    try {
      if (StateName.trim().length >= 2) {
        const data = { StateId, StateName, ModifiedBy };
        const response = await fetch(ConcateURL + 'UpdateState/' + Id, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Token}`
          },
          body: JSON.stringify(data)
        });

        const result = await parseJSON(response);
        if (result && result.returnID !== undefined) {
          setreturnId(result.returnID);
          getAllState();
          doEmptyStates();
          enqueueSnackbar('Successfully Updated', { variant: 'success' });
        } else {
          enqueueSnackbar('Update failed: empty response', { variant: 'error' });
        }
      }
      else {
        enqueueSnackbar('Please enter state name', { variant: 'warning' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const activateDeactivateState = async (Id, Value) => {
    try {
      const data = { Value };
      const response = await fetch(ConcateURL + 'ActivateDeactivateState/' + Id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify(data)
      });

      const result = await parseJSON(response);
      if (result && result.returnID !== undefined) {
        setreturnId(result.returnID);
        getAllState();
        doEmptyStates();

        Value === 'activate'
          ? enqueueSnackbar('Successfully Activated', { variant: 'success' })
          : enqueueSnackbar('Successfully Deactivated', { variant: 'warning' });
      } else {
        enqueueSnackbar('Status change failed: empty response', { variant: 'error' });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const result = stateList.filter((x) => {
      const stateName = (x.StateName || x.State || '').toLowerCase();
      return stateName.match(search.toLowerCase());
    });

    setfilterstateList(result);
  }, [search, stateList]);

  const coloumn = [
    {
      name: <strong>SNo.</strong>,
      selector: (row, index) => index + 1
    },
    {
      name: <strong>Reference Id</strong>,
      selector: (row) => row.StateId
    },
    {
      name: <strong>State Name</strong>,
      selector: (row) => row.StateName || row.State,
      sortable: true,
      reorder: true
    },
    {
      name: <strong>Activated/Deactivated</strong>,
      selector: (row) => row.IsActive
        ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
        : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Deactivated</label>
    },
    {
      name: <strong>Action</strong>,
      cell: (row) =>
        <div>
          {
            !row.IsActive
              ? <Button onClick={() => activateDeactivateState(row.StateId, 'activate')} data-tip="Click to Activate State" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-toggle-off" aria-hidden="true"></i></Button>
              : <Button onClick={() => activateDeactivateState(row.StateId, 'deactivate')} data-tip="Click to Deactivate State" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-toggle-on" aria-hidden="true"></i></Button>
          }
          <Button onClick={() => editState(row.StateId)} data-tip="Click to Edit Details" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        </div>
    }
  ];

  return (
    <div>
      <Layout>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">
                Add New State
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div>
                  <label htmlFor="stateName" className="block text-sm font-medium text-gray-700 mb-2">
                    State Name
                  </label>
                  <input
                    type="text"
                    id="stateName"
                    name="stateName"
                    value={StateName}
                    ref={StateInputRef}
                    onChange={(e) => { setStateName(e.target.value); }}
                    placeholder="Enter State Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                  />
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-3">
                {
                  edit === false
                    ? <Button className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2" onClick={() => insertState()}><span>Add</span></Button>
                    : <Button className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2" onClick={() => updateState(returnId)}><span>Update</span></Button>
                }

                <button
                  type="button"
                  onClick={() => doEmptyStates()}
                  className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <DataTable
                  title="Manage State"
                  columns={coloumn}
                  data={filterstateList}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="550px"
                  selectableRows
                  selectableRowsHighlight
                  highlightOnHover
                  subHeader
                  subHeaderAlign="right"
                  subHeaderComponent={
                    <input
                      type="text"
                      placeholder="search state"
                      className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                    />
                  }
                />
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </div>
  );
}

export default State;
